import { render, staticRenderFns } from "./QuizsetMain.vue?vue&type=template&id=74e64a26&scoped=true&"
import script from "./QuizsetMain.vue?vue&type=script&lang=js&"
export * from "./QuizsetMain.vue?vue&type=script&lang=js&"
import style0 from "./QuizsetMain.vue?vue&type=style&index=0&id=74e64a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e64a26",
  null
  
)

export default component.exports